module.exports = __webpack_public_path__ + "static/media/uiet_logo.0342b676.png";